//dependencies

//services
import cookieConsent from "emun.auth/cookie-consent/cookie-consent";
import "emun.auth/cookie-consent/cookie-consent.scss";

//components

export const dependencies = [];

export const modules = {};

export const services = {};

export const runners = {};

export const components = { cookieConsent };

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  runners,
};
